const selectTableSplit = {
  tables: {
    searchPlaceholder: 'Suchen',
  },
};

export default selectTableSplit;
